<template>
  <div class="root">
    <loading v-if="mask" />
    <transition
      enter-active-class="fade-enter-active"
      leave-active-class="fade-leave-active"
    >
      <modal v-if="popup" class="popup-modal">
        <div slot="body">
          <popup :title="popupInfo.title" :content="popupInfo.content" />
        </div>
      </modal>
    </transition>
    <router-view name="header" />
    <router-view />
    <router-view name="sidemenu" />

    <!-- success msg modal -->
    <transition name="custom-modal">
      <modal v-if="successMsg" class="msg-modal">
        <div slot="header">系統訊息</div>
        <div slot="body">
          <div v-html="successMsg"></div>
        </div>
        <div slot="footer">
          <Button text="Close" @onClick="successModalClose()"></Button>
        </div>
      </modal>
    </transition>

    <!-- error msg modal -->
    <transition name="custom-modal">
      <modal v-if="errorMsg" class="msg-modal">
        <div slot="header">系統訊息</div>
        <div slot="body">
          <div>{{ errorMsg }}</div>
        </div>
        <div slot="footer">
          <Button text="Close" @onClick="errorModalClose()"></Button>
        </div>
      </modal>
    </transition>

    <!-- confirm modal -->
    <transition name="custom-modal">
      <modal v-if="confirmModal.show" class="msg-modal">
        <div slot="header">{{ confirmModal.title || '系統訊息' }}</div>
        <div slot="body">
          <div>{{ confirmModal.content }}</div>
        </div>
        <div slot="footer" class="button-group">
          <Button :text="confirmModal.confirmText || '確認'" @onClick="handleConfirmModal(true)"></Button>
          <Button :text="confirmModal.cancelText || '取消'" @onClick="handleConfirmModal(false)" class="cancel-btn"></Button>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import store from 'Store/store';
import Loading from 'Components/mask.vue';
import Modal from 'Components/modal.vue';
import Button from 'Components/button/pureButton.vue';
import Popup from 'Components/popup.vue';

export default {
  name: 'Container',
  components: {
    Loading,
    Modal,
    Button,
    Popup,
  },
  computed: {
    mask() {
      return store.state.main.mask;
    },
    popup() {
      return (
        store.state.main.popup.title !== '' &&
        store.state.main.popup.content !== ''
      );
    },
    popupInfo() {
      return store.state.main.popup;
    },
    errorMsg() {
      return store.state.main.errorMsg;
    },
    errorAction() {
      return store.state.main.errorAction;
    },
    successMsg() {
      return store.state.main.successMsg;
    },
    successAction() {
      return store.state.main.successAction;
    },
    showPopup() {
      return store.state.main.popup;
    },
    confirmModal() {
      return store.state.main.confirmModal;
    },
  },
  methods: {
    errorModalClose() {
      // 關閉errorMsgModal
      store.dispatch('main/clearErrorMsg');

      //執行errorModal關閉後的指定action
      if (this.errorAction) {
        store.dispatch(this.errorAction);
      }
    },
    successModalClose() {
      // 關閉successMsgModal
      store.dispatch('main/clearSuccessMsg');

      //執行successModal關閉後的指定action
      if (this.successAction) {
        store.dispatch(this.successAction);
      }
    },
    handleConfirmModal(isConfirm) {
      if (isConfirm) {
        if (this.confirmModal.onConfirm) {
          this.confirmModal.onConfirm();
        }
      } else {
        if (this.confirmModal.onCancel) {
          this.confirmModal.onCancel();
        }
      }
      store.dispatch('main/hideConfirmModal');
    },
  },
  created() {},
  mounted() {
    store.dispatch('main/checkOnlineStatus');
    store.dispatch('main/getReferenceData');
  },
  watch: {
    $route() {
      window.scrollTo({ behavior: 'auto', top: 0 });
    },
  },
};
</script>

<style scoped>
.msg-modal /deep/ .custom-modal-body {
  text-align: left;
  color: #000000;
  padding: 0 20px;
}

.fade-enter-active {
  animation: show 0.5s;
}

.fade-leave-active {
  animation: hide 0.5s;
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.temple-button-text.cancel {
  background-color: #999;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.cancel-btn {
  background-color: #999 !important;
}
</style>
